<template>
	<b-modal
		id="warningModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
	>
		<div class="d-flex w-100 mt-2">
			<div>
				<img src="../../../assets/common-icons/warning-icon.svg" alt="" />
			</div>
			<div class="d-flex align-items-center w-90 flex-column ml-3">
				<div class="d-flex align-items-center justify-content-between w-100">
					<div class="modal-head">
						Warning
					</div>
					<div>
						<img
							class="pointer"
							src="../../../assets/projects-icons/x-close.svg"
							alt=""
						/>
					</div>
				</div>
				<div class="mt-1 modal-content-font">
					Are you sure you want to terminate the project for the candidate
					<span class="modal-content-email">
						"john.smith@example.com"?
					</span>
				</div>
			</div>
		</div>
		<div class="mt-4 mb-3 d-flex align-items-center justify-content-end w-100">
			<div class="mr-3"><b-button class="new-cancelBtn">Cancel</b-button></div>
			<div><b-button class="new-addBtn">Save</b-button></div>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "WarningModal",
	data() {
		return {};
	},
};
</script>
